import { preChat as esPreChat } from '../es/preChat';

export const preChat: typeof esPreChat = {
  ...esPreChat,
  PHONE_PLACEHOLDER: 'XXXX XXXX',
};
